"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveStudentNote = exports.UpdateStudentNote = exports.AddStudentNote = exports.GetStudentNotes = void 0;
var HttpClient_1 = require("../core/HttpClient");
var queryString_1 = require("../../../app/common/helpers/queryString");
/**
 * List a student's notes, newest first, paginated.
 * Backend: StudentNotesController@index
 */
var GetStudentNotes = function (studentId, params) {
    if (params === void 0) { params = {}; }
    var query = (0, queryString_1.toQueryString)(params);
    return HttpClient_1.HttpClient.get("/users/students/".concat(studentId, "/notes").concat(query ? "?".concat(query) : ""));
};
exports.GetStudentNotes = GetStudentNotes;
/**
 * Backend: StudentNotesController@store
 */
var AddStudentNote = function (studentId, payload) {
    return HttpClient_1.HttpClient.post("/users/students/".concat(studentId, "/notes"), payload);
};
exports.AddStudentNote = AddStudentNote;
/**
 * Backend: StudentNotesController@update
 */
var UpdateStudentNote = function (studentId, noteId, payload) {
    return HttpClient_1.HttpClient.put("/users/students/".concat(studentId, "/notes/").concat(noteId), payload);
};
exports.UpdateStudentNote = UpdateStudentNote;
/**
 * Backend: StudentNotesController@destroy
 */
var RemoveStudentNote = function (studentId, noteId) {
    return HttpClient_1.HttpClient.delete("/users/students/".concat(studentId, "/notes/").concat(noteId));
};
exports.RemoveStudentNote = RemoveStudentNote;
